import ComponentLayout from "../../../../src/layouts/component-layout";
import { defaultStackDirection, defaultStackSpacing, StackAlignItemVariants, StackSpacingVariants, StackDirectionVariants, StackJustifyContentVariants } from '@primer/react-brand';
import { PropTableValues } from "../../../../src/components";
import * as React from 'react';
export default {
  ComponentLayout,
  defaultStackDirection,
  defaultStackSpacing,
  StackAlignItemVariants,
  StackSpacingVariants,
  StackDirectionVariants,
  StackJustifyContentVariants,
  PropTableValues,
  React
};